// extracted by mini-css-extract-plugin
export var button = "_64-4";
export var hasDarkBackground = "_64-7";
export var hasLightBackground = "_64-6";
export var iconWrapper = "_64-0";
export var large = "_64-2";
export var medium = "_64-1";
export var small = "_64-5";
export var xsmall = "_64-3";